<div class="d-flex align-items-center text-center">
	<ws-input-date [(result)]="result" (resultChange)="resultChange.emit($event)" [asRange]="true"></ws-input-date>
	<div class="ml-2 x" *ngIf="!!result && result.from && result.to">
		<mat-icon class="col-2 icon-primary pointer p-0" (click)="reset()">close</mat-icon>
	</div>
</div>
